import { useState } from 'react';
import { Card } from '@/components/Card/Card';
import { t } from '@/lib/i18n';
import { ComingSoonModal } from './ComingSoonModal';
import styles from './SecondaryActionsRow.module.css';

type OpenModal = 'tour' | 'invite' | 'setup' | null;

export function SecondaryActionsRow() {
  const [open, setOpen] = useState<OpenModal>(null);
  const close = () => setOpen(null);

  return (
    <section className={styles.row} aria-label={t('Or do something else first')}>
      <p className={styles.label}>{t('Or do something else first')}</p>
      <div className={styles.grid}>
        <Card
          padding="sm"
          className={styles.item}
          onClick={() => setOpen('tour')}
          role="button"
          tabIndex={0}
        >
          <span className={styles.icon} aria-hidden>
            ⇢
          </span>
          <span>{t('Take a tour')}</span>
        </Card>
        <Card
          padding="sm"
          className={styles.item}
          onClick={() => setOpen('invite')}
          role="button"
          tabIndex={0}
        >
          <span className={styles.icon} aria-hidden>
            +
          </span>
          <span>{t('Invite a teammate')}</span>
        </Card>
        <Card
          padding="sm"
          className={styles.item}
          onClick={() => setOpen('setup')}
          role="button"
          tabIndex={0}
        >
          <span className={styles.icon} aria-hidden>
            ⚙
          </span>
          <span>{t('Finish Workspace setup')}</span>
        </Card>
      </div>

      <ComingSoonModal
        open={open === 'tour'}
        onOpenChange={(o) => (o ? setOpen('tour') : close())}
        icon="▶"
        title={t('Take a tour')}
        body={
          <p>
            {t(
              'We’re putting together a quick walkthrough of the basics — meeting your team, assigning Jobs, and reviewing what gets delivered. Check back soon.',
            )}
          </p>
        }
      />

      <ComingSoonModal
        open={open === 'invite'}
        onOpenChange={(o) => (o ? setOpen('invite') : close())}
        icon="✉"
        title={t('Invite a teammate')}
        body={
          <p>
            {t(
              'Bring teammates into your Workspace and give each one the right access. We’re finishing the invitation flow — for now, you’re flying solo.',
            )}
          </p>
        }
      />

      <ComingSoonModal
        open={open === 'setup'}
        onOpenChange={(o) => (o ? setOpen('setup') : close())}
        icon="⚙"
        title={t('Finish Workspace setup')}
        body={
          <p>
            {t(
              'Workspace settings will let you tune billing, branding, defaults, and integrations. The full setup flow is on its way.',
            )}
          </p>
        }
      />
    </section>
  );
}
